import type { Deck } from '@/entities/deck'
import { getSite } from '@/lib/site-viewer/site-loader'
import type { DeepReadonly } from 'vue'

export default function usePreloadSiteImages({ deck, uuid }: { deck: DeepReadonly<Ref<Deck>>; uuid?: string }) {
  onMounted(async () => {
    const promises = deck.value.slides
      .filter(({ type, site_id }) => type === 'S' && !!site_id)
      .map(({ site_id }) => getSite(<number>site_id, { uuid }))

    await Promise.all(promises)
  })
}
